const INTERNAL_DUMMY_QUERY_KEY = '__ce_internal_dummy';
const INTERNAL_DUMMY_QUERY_VALUE = 'soldout-lab';
const INTERNAL_DUMMY_QUERY_ALIAS_KEY = 'dummy';
const INTERNAL_DUMMY_QUERY_ALIAS_VALUE = '1';
const INTERNAL_DUMMY_LOCALSTORAGE_KEY = '__CE_INTERNAL_DUMMY_KEY__';
const INTERNAL_DUMMY_LOCALSTORAGE_VALUE = '1';

function hasInternalDummyDataTrigger(win) {
  const runtimeWindow = win || (typeof window !== 'undefined' ? window : null);
  if (!runtimeWindow) return false;

  try {
    const search = runtimeWindow.location && typeof runtimeWindow.location.search === 'string'
      ? runtimeWindow.location.search
      : '';
    const params = new URLSearchParams(search);
    const queryMatched = params.get(INTERNAL_DUMMY_QUERY_KEY) === INTERNAL_DUMMY_QUERY_VALUE
      || params.get(INTERNAL_DUMMY_QUERY_ALIAS_KEY) === INTERNAL_DUMMY_QUERY_ALIAS_VALUE;
    if (queryMatched) {
      if (runtimeWindow.localStorage) {
        runtimeWindow.localStorage.setItem(INTERNAL_DUMMY_LOCALSTORAGE_KEY, INTERNAL_DUMMY_LOCALSTORAGE_VALUE);
      }
      return true;
    }

    const localMatched = runtimeWindow.localStorage
      && runtimeWindow.localStorage.getItem(INTERNAL_DUMMY_LOCALSTORAGE_KEY) === INTERNAL_DUMMY_LOCALSTORAGE_VALUE;
    return !!localMatched;
  } catch (error) {
    return false;
  }
}

function getDummyFavouriteProducts() {
  return [
    {
      id: null,
      categoryId: 0,
      favouriteUrl: '__internal_dummy_fav_1__',
      productLink: '',
      image: 'https://images.unsplash.com/photo-1517841905240-472988babdf9?q=80&w=1200&auto=format&fit=crop',
      price: '€89.00',
      text: '[INTERNAL DUMMY] Soft Wool Jacket',
      sellerName: 'Dummy Seller A',
      sellerImage: 'https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?q=80&w=240&auto=format&fit=crop',
      sellerReviews: '12 reviews',
      itemStatus: 3,
      isOffShelf: true,
      __internalDummy: true,
    },
    {
      id: null,
      categoryId: 0,
      favouriteUrl: '__internal_dummy_fav_2__',
      productLink: '',
      image: 'https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?q=80&w=1200&auto=format&fit=crop',
      price: '€34.00',
      text: '[INTERNAL DUMMY] Everyday Tee',
      sellerName: 'Dummy Seller B',
      sellerImage: 'https://images.unsplash.com/photo-1544723795-3fb6469f5b39?q=80&w=240&auto=format&fit=crop',
      sellerReviews: '9 reviews',
      itemStatus: 0,
      isOffShelf: false,
      __internalDummy: true,
    },
    {
      id: null,
      categoryId: 0,
      favouriteUrl: '__internal_dummy_fav_3__',
      productLink: '',
      image: 'https://images.unsplash.com/photo-1542291026-7eec264c27ff?q=80&w=1200&auto=format&fit=crop',
      price: '€67.00',
      text: '[INTERNAL DUMMY] Retro Sneakers',
      sellerName: 'Dummy Seller C',
      sellerImage: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?q=80&w=240&auto=format&fit=crop',
      sellerReviews: '27 reviews',
      itemStatus: 7,
      isOffShelf: true,
      __internalDummy: true,
    },
  ];
}

function getDummyCartItems() {
  return [
    {
      id: '__internal_dummy_cart_1__',
      productId: '__internal_dummy_cart_1__',
      categoryId: '0',
      title: '[INTERNAL DUMMY] Sold Out Hoodie',
      price: '€52.00',
      image: 'https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?q=80&w=800&auto=format&fit=crop',
      quantity: 1,
      sellerName: 'Dummy Seller A',
      itemStatus: 2,
      __internalDummy: true,
    },
    {
      id: '__internal_dummy_cart_2__',
      productId: '__internal_dummy_cart_2__',
      categoryId: '0',
      title: '[INTERNAL DUMMY] Available Cap',
      price: '€18.00',
      image: 'https://images.unsplash.com/photo-1521369909029-2afed882baee?q=80&w=800&auto=format&fit=crop',
      quantity: 2,
      sellerName: 'Dummy Seller B',
      itemStatus: 0,
      __internalDummy: true,
    },
    {
      id: '__internal_dummy_cart_3__',
      productId: '__internal_dummy_cart_3__',
      categoryId: '0',
      title: '[INTERNAL DUMMY] Sold Out Boots',
      price: '€96.00',
      image: 'https://images.unsplash.com/photo-1542291026-7eec264c27ff?q=80&w=800&auto=format&fit=crop',
      quantity: 1,
      sellerName: 'Dummy Seller C',
      itemStatus: 9,
      __internalDummy: true,
    },
  ];
}

const internalDummyData = {
  INTERNAL_DUMMY_QUERY_KEY,
  INTERNAL_DUMMY_QUERY_VALUE,
  INTERNAL_DUMMY_QUERY_ALIAS_KEY,
  INTERNAL_DUMMY_QUERY_ALIAS_VALUE,
  INTERNAL_DUMMY_LOCALSTORAGE_KEY,
  INTERNAL_DUMMY_LOCALSTORAGE_VALUE,
  hasInternalDummyDataTrigger,
  getDummyFavouriteProducts,
  getDummyCartItems,
};

module.exports = internalDummyData;
module.exports.default = internalDummyData;